import React from "react"
import { HelpOutline } from "@mui/icons-material"
import { Box, BoxProps, Tooltip } from "@mui/material"

interface Props extends BoxProps {
  text: string
}

const QuestionHelper = ({ text, ...boxProps }: Props) => {
  return (
    <Tooltip arrow title={text}>
      <Box display="flex" alignItems="center" {...boxProps}>
        <HelpOutline fontSize="small" />
      </Box>
    </Tooltip>
  )
}

export default QuestionHelper
